import { IconProps } from "../../utils/global-types/global-types";

const TerminatedIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path fill="currentColor" d="M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14"></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M6.603 6.33h4.794c.15 0 .273.123.273.273v4.794c0 .15-.123.273-.273.273H6.603a.274.274 0 0 1-.273-.273V6.603c0-.15.123-.273.273-.273"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default TerminatedIcon;
